
export enum NotificationCategory {
  EmployeeHandover = 1,
  CustomerHandover = 2,
  Recreation = 3,
  IncidentReport = 4,
  NearMiss = 5,
}

export const notificationCategoryOptions = [
  {
    value: NotificationCategory.EmployeeHandover,
    label: "従業員申し送り（件ごと）　一覧",
  },
  {
    value: NotificationCategory.CustomerHandover,
    label: "お客様申し送り（1日単位でまとめ）　ツリー",
  },
  { value: NotificationCategory.Recreation, label: "レクリエーション" },
  { value: NotificationCategory.IncidentReport, label: "事故報告" },
  { value: NotificationCategory.NearMiss, label: "ヒアリハット" },
];

const commonFields = {
  targetPerson: {
    label: "対象者",
    required: true,
    name: "target_person",
    disabled: false,
    type: "text",
  },
  discoverer: {
    label: "発見者",
    required: true,
    name: "discoverer",
    disabled: false,
    type: "text",
  },
  occurredAt: {
    label: "発生日時",
    required: true,
    name: "occurred_at",
    disabled: false,
    type: "dateTime",
  },
  responseAction: {
    label: "発生後の対応",
    required: true,
    name: "response_action",
    disabled: false,
    type: "textarea",
  },
  poster: {
    label: "記入者",
    required: true,
    name: "poster",
    type: "poster",
    disabled: true,
  },
  seen: {
    label: "確認者",
    required: true,
    name: "seen",
    type: "seen",
    disabled: true,
  },
  file: {
    label: "画像を選択",
    required: false,
    name: "file",
    disabled: false,
    type: "file",
  },
};
export const NearMissFields = [
  commonFields.targetPerson,
  commonFields.discoverer,
  commonFields.occurredAt,
  {
    label: "発生状況",
    required: true,
    name: "occurrence_status",
    disabled: false,
    type: "textarea",
  },
  commonFields.responseAction,
  commonFields.poster,
  commonFields.seen,
  commonFields.file,
];


// apply for notificationCategoryOptions choose IncidentReport
export const IncidentReportFields = [
  commonFields.targetPerson,
  commonFields.discoverer,
  commonFields.occurredAt,
  {
    label: "種類",
    required: true,
    name:  "occurrence_type",
    disabled: false,
    type: "select",
    options: [
      { label: "訪問事故", value: "visit" },
      { label: "施設事故", value: "facility" },
      { label: "医療事故", value: "medical" },
      { label: "救急", value: "emergency" },
      { label: "その他", value: "other" },
    ],
  },
  {
    label: "事故状況",
    required: true,
    name:  "incident_detail",
    disabled: false,
    type: "textarea",
  },
  commonFields.responseAction,
  {
    label: "今後の改善点",
    required: true,
    name:  "confirmer",
    disabled: false,
    type: "textarea",
  },
  commonFields.poster,
  commonFields.seen,
  commonFields.file,
];


// apply for notificationCategoryOptions choose rest options
export const RestFields = [
  {
    label: "内容",
    name:  "content",
    required: true,
    disabled: false,
    type: "textarea",
  },
  commonFields.poster,
  commonFields.seen,
  commonFields.file,
];
